import React from 'react';

const SeoText = ({title, content}) => {
  return <div className="seo-text">
    <h3>{title}</h3>
    <span>{content}</span>
  </div>
};

export default SeoText;
